export enum PartnerType {
  Commission = 'commission',
  Distribution = 'distribution',
  DealPassing = 'deal_passing',
}

const PARTNER_TYPES_BY_URL_TYPE = new Map<string, PartnerType>([
  ['c', PartnerType.Commission],
  ['commission', PartnerType.Commission],
  ['d', PartnerType.Distribution],
  ['deal_passing', PartnerType.DealPassing],
  ['distribution', PartnerType.Distribution],
  ['p', PartnerType.DealPassing],
]);

export const resolvePartnerType = (urlType: string): PartnerType | undefined => PARTNER_TYPES_BY_URL_TYPE.get(urlType);

const URL_TYPES_BY_PARTNER_TYPE: Record<PartnerType, string> = {
  [PartnerType.Commission]: 'c',
  [PartnerType.DealPassing]: 'p',
  [PartnerType.Distribution]: 'd',
};

export const toPartnerUrlType = (partnerType: PartnerType): string => URL_TYPES_BY_PARTNER_TYPE[partnerType];
